<link rel="stylesheet" href="https://unpkg.com/leaflet/dist/leaflet.css" />

@switch (data?.type) {
  @case ('heat-map') {
    <app-heatmap [data]="data"></app-heatmap>
  }
  @case ('choropleth-map') {
    <app-choropleth-map [data]="data"></app-choropleth-map>
  }
  @case ('pin-map') {
    <app-map [data]="data"></app-map>
  }
  @case ('route-map') {
    @if (analyzeData && analyzeData.nodes && analyzeData.pinmap) {
      <app-route-map [data]="data" [networkgraphdata]="analyzeData" (openSidebar)="onOpenSidebar($event)"></app-route-map>
    }
  }
}
